import { render, staticRenderFns } from "./blockBox.vue?vue&type=template&id=19742fe4&"
import script from "./blockBox.vue?vue&type=script&lang=js&"
export * from "./blockBox.vue?vue&type=script&lang=js&"
import style0 from "./blockBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports